/**
 * @name AppVersionController
 * @description Controller for the AppVersion component
 * @param {service} Session The Session service
 * @param {angular} $window The $window service from Angular
 * @param {service} AppVersion The AppVersion service
 */
function AppVersionController(
  Session,
  $window,
  AppVersion
) {
  let vm = this;
  vm.$onInit = function() {
    vm.reloadBrowser = reloadBrowser;
    Session.cancelAppVersionPoll();
  };

  let getDescriptions = true;
  AppVersion.get(getDescriptions).then(function(appVersions) {
    vm.appVersions = appVersions;
  });

  /**
   * @name reloadBrowser
   * @description Function to reload the browser
   */
  function reloadBrowser() {
    $window.location.reload();
  }
}

angular
  .module('inkfinder')
  .controller('AppVersionController', AppVersionController);



// WEBPACK FOOTER //
// ./components/app-version/app-version.controller.js